import axios from "axios";
import http from "Utils/api2";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");
export const getProductsWithoutLoading = createAsyncThunk(
  "eCommerce/getAllProduct",
  async (url) => {
    try {
      const res = await http.get(url);
      return res.data;
    } catch (error) {
      return { data: null };
    }
  }
);
export const getAllGlobalProducts = createAsyncThunk("getAllGlobalProducts", async (url) => {
  try {
    const res = await http.get(url);
    return res.data;
  } catch (error) {
    return { data: null };
  }
});
export const getSingleProduct = createAsyncThunk("getSingleProduct", async (data) => {
  try {
    // const res = await http.get(url);
    return { data };
  } catch (error) {
    return { data: null };
  }
});
export const updateProducts = createAsyncThunk("updateProducts", async ({ url, data }) => {
  ;
  ;

  const res = await fetch(url, {
    method: "PUT",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    body: data,
  });
  return await res.json();
});
export const disableProducts = createAsyncThunk("disableProducts", async ({ url, data }) => {
  ;
  ;

  const res = await fetch(url, {
    method: "PATCH",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    body: data,
  });
  return await res.json();
});
export const deleteProducts = createAsyncThunk("", async ({ url, data }) => {
  ;
  ;deleteProducts

  const res = await fetch(url, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    body: data,
  });
  return await res.json();
});
export const createProducts = createAsyncThunk("createProducts", async ({ url, data }) => {
  try {
    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
});
export const updateProduct = createAsyncThunk("updateProduct", async ({ url, data }) => {
  try {
    const response = await axios.put(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    return response.data;
  } catch (error) {
    return error.response?.data || { success: false, message: error.message };
  }
});
export const updateProductPic = createAsyncThunk("updateProductPic", async ({ url, data }) => {
  ;
  ;
  const isData = data;
  ;
  ;
  try {
    const response = await http.put(url, isData, {
      headers: {
        // "Content-Type": "multipart/form-data",
        // Accept: "application/json",
        authorization: localStorage.getItem("token"),
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
});

const productSlice = createSlice({
  name: "products",
  initialState: {
    Loading: false,
    AllProducts: null,
    page: null,
    singleProduct: null,
    createUpdateLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllGlobalProducts.pending, (state, action) => {
        state.Loading = true;
      })
      .addCase(getAllGlobalProducts.fulfilled, (state, action) => {
        state.Loading = false;
        state.AllProducts = action.payload?.data;
        state.page =
          action.payload?.totalPages ||
          (action.payload?.totalProducts
            ? Math.ceil(action.payload.totalProducts / 10)
            : state.page || 1);
      })
      .addCase(getProductsWithoutLoading.fulfilled, (state, action) => {
        state.AllProducts = action.payload?.data;
        state.page =
          action.payload?.totalPages ||
          (action.payload?.totalProducts
            ? Math.ceil(action.payload.totalProducts / 10)
            : state.page || 1);
      })
      .addCase(getAllGlobalProducts.rejected, (state, action) => {
        state.Loading = false;
      })
      .addCase(createProducts.pending, (state, action) => {
        state.createUpdateLoading = true;
      })
      .addCase(createProducts.fulfilled, (state, action) => {
        state.createUpdateLoading = false;
        // state.AllProducts = action.payload?.data;
        // state.page = action.payload?.page;
      })
      .addCase(createProducts.rejected, (state, action) => {
        state.createUpdateLoading = false;
      })
      .addCase(updateProduct.pending, (state, action) => {
        state.createUpdateLoading = true;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.createUpdateLoading = false;
        // state.AllProducts = action.payload?.data;
        // state.page = action.payload?.page;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.createUpdateLoading = false;
      })
      .addCase(getSingleProduct.pending, (state, action) => {
        state.Loading = true;
      })
      .addCase(getSingleProduct.fulfilled, (state, action) => {
        state.Loading = false;
        state.singleProduct = action.payload?.data;
        // state.page = action.payload?.page;
      })
      .addCase(getSingleProduct.rejected, (state, action) => {
        state.Loading = false;
      });
  },
});
export default productSlice.reducer;
